import { useState } from 'react';
import { Col, Row } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';

import Avatar from 'global/Avatar';
import If from 'global/Common/If';
import { TargetType } from 'typings/api/shareTradeTarget';

import { ShareTradeInfo } from 'typings/api/shareTradeChat';
import { Text } from '../styled';
import {
  Checkbox,
  Description,
  IconVerified,
  NameWrapper,
  UserInfoRow,
} from './styled';
import PopOverInvestment from '../PopOverInvestment';

interface UserItemProps {
  avatarUrl?: string;
  name?: string;
  alias?: string;
  description?: string;
  targetType?: TargetType;
  isVerified?: boolean;
  defaultChecked?: boolean;
  disabled?: boolean;
  defaultSwitchValue?: boolean;
  previewShareTrade: ShareTradeInfo | Record<string, never>;
  isScrolling?: boolean;
  onCheckChange?(e: CheckboxChangeEvent): void;
  onSwitchChange?(checked: boolean): void;
}

const UserItem = ({
  avatarUrl,
  name,
  alias,
  description,
  targetType,
  isVerified = false,
  defaultChecked = false,
  disabled = false,
  defaultSwitchValue = false,
  previewShareTrade,
  isScrolling = false,
  onCheckChange = () => { },
  onSwitchChange = () => { },
}: UserItemProps) => {
  const [isSelected, setIsSelected] = useState<boolean>(defaultChecked);

  const handleChangeCheckbox = (e: CheckboxChangeEvent) => {
    setIsSelected(e.target.checked);
    onCheckChange(e);
  };

  return (
    <>
      <Row align="middle" justify="space-between">
        <Col span={22}>
          <UserInfoRow align="middle">
            <Col className="avatar-col">
              {targetType === TargetType.User && (
                <Avatar src={avatarUrl} alt={name} />
              )}
              {targetType === TargetType.ChatRoom && (
                <Avatar src={avatarUrl}>{avatarUrl ? undefined : alias}</Avatar>
              )}
            </Col>

            <Col span={20}>
              <NameWrapper align="middle">
                <Text weight="bold">{name}</Text>
                {isVerified && (
                  <IconVerified src="/icon/widget-trending/icon-verfied.svg" alt="icon-verified" />
                )}
              </NameWrapper>
              <If condition={!isSelected || disabled}>
                <Description size="12px" lineHeight="19px" color="#969696">
                  {description}
                </Description>
              </If>
              <If condition={isSelected && !disabled}>
                <PopOverInvestment
                  defaultSwitchValue={defaultSwitchValue}
                  isSelected={isSelected}
                  previewShareTrade={previewShareTrade}
                  isScrolling={isScrolling}
                  onSwitchChange={onSwitchChange}
                />
              </If>
            </Col>
          </UserInfoRow>
        </Col>

        <Col>
          <Checkbox
            defaultChecked={defaultChecked}
            onChange={handleChangeCheckbox}
            disabled={disabled}
            // Set to controlled comp when disabled
            {...(disabled ? { checked: false } : {})}
          />
        </Col>
      </Row>
    </>
  );
};

export default UserItem;
